import { GROUP_COLOR_MAP } from "./apt-group-const"

const AptGroupButton = ({ label, colorKey, isFavorite = false, isActive = false, onClick }) => {
  const color = GROUP_COLOR_MAP[colorKey] ?? GROUP_COLOR_MAP.blue

  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={isActive}
      className={`inline-flex shrink-0 items-center gap-2 rounded-xl border px-3.5 py-2 text-sm font-semibold transition-colors ${
        isActive
          ? `${color.bgColor} ${color.borderColor} ${color.textClassName}`
          : "border-slate-200 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-100"
      }`}
    >
      {isFavorite ? (
        <svg
          viewBox="0 0 24 24"
          fill="currentColor"
          className="h-4 w-4 shrink-0"
          aria-hidden="true"
        >
          <path d="M12 2.5l2.93 5.94 6.56.95-4.75 4.63 1.12 6.54L12 17.47l-5.86 3.09 1.12-6.54L2.5 9.39l6.57-.95L12 2.5z" />
        </svg>
      ) : (
        <span className={`h-2.5 w-2.5 shrink-0 rounded-full ${color.ballColor}`} />
      )}

      <span>{label}</span>
    </button>
  )
}

export default AptGroupButton
